import React from 'react';
import { Link } from 'react-router-dom';
import './dashboard.css';  // Import the CSS file here

const Dashboard = () => {
  // Unsplash random image URL with timestamp to avoid caching
const images = [
  'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1920&q=80',
  'https://images.unsplash.com/photo-1525182008055-f88b95ff7980?auto=format&fit=crop&w=1920&q=80',
  'https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1920&q=80',
  "https://images.unsplash.com/photo-1501854140801-50d01698950b?q=80&w=1275&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://plus.unsplash.com/premium_photo-1685793803975-2f330a16ee10?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  "https://images.unsplash.com/photo-1479030160180-b1860951d696?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//   "https://unsplash.com/photos/a-gold-bar-and-five-gold-coins-on-a-shiny-surface-2NOR4ngJGrc",

];
const randomIndex = Math.floor(Math.random() * images.length);
const randomBackgroundUrl = images[randomIndex];

  return (
  <div className='maincont'>
      {/* Background div */}
      <div
        className="dashboard-background"
        style={{ backgroundImage: `url(${randomBackgroundUrl})` }}
      />

      {/* Main dashboard content */}
      <div className="dashboard-container">
        <h2 className="dashboard-title">Trezi Admin Dashboard</h2>
        <ul className="dashboard-menu-list">
            <li className="dashboard-menu-item">
            <Link className="dashboard-link" to="/signup">Sign Up New User</Link>
          </li>
          <li className="dashboard-menu-item">
            <Link className="dashboard-link" to="/users-list">View Signed-up Users</Link>
          </li>
          <li className="dashboard-menu-item">
            <Link className="dashboard-link" to="/verify-email">Verify User Email</Link>
          </li>
          <li className="dashboard-menu-item">
            <Link className="dashboard-link" to="/subscriptions">Subscription Details</Link>
          </li>
          <li className="dashboard-menu-item">
            <Link className="dashboard-link" to="/create-subscription">Create Subscription</Link>
          </li>
        </ul>
      </div>
      </div>
  );
};

export default Dashboard;
